import { Component, Input, OnInit } from '@angular/core';
import { GeneralService } from '@ex/module/core/services/general.service';
import { ModuleName } from '../../enums/ModuleName';

@Component({
  selector: 'generation-info',
  templateUrl: './generation-info.component.html',
  styleUrls: ['./generation-info.component.scss']
})
export class GenerationInfoComponent implements OnInit {
  @Input() language: string = 'AR';
  ModuleNames = ModuleName;
  constructor(public generalService: GeneralService) { }

  ngOnInit(): void {
  }

}
